import type { MapperOptions } from '#layers/core/types'
import { mapperBlockCallToAction } from '../../../core/data-layer/blocks/mappers'
import type { CallToAction, Chapter } from '#layers/core/types/mappers'

type PagePaymentMethodsGlossaryData = {
  introText: string | null
  chapters: Chapter & { subchapters: Chapter[] }[]
  callToAction: CallToAction | null
}

export default (data: any, options: MapperOptions): PagePaymentMethodsGlossaryData | null => {
  if (!data) {
    return null
  }

  let callToAction = null

  if (options.getUrl) {
    callToAction = mapperBlockCallToAction(data.callToAction, options.getUrl)
  }

  return {
    introText: data.introText || null,
    chapters: data.chaptersCollection?.items || [],
    callToAction
  }
}
